<template>
    <div class="card">
        <form @submit.prevent="onCreateJobStack">
            <div class="card-body">
                <FormFields :fields="fields" v-model="jobStack" />
                <div v-if="error" class="text-danger">
                    {{ error }}
                </div>
            </div>
            <div class="card-footer">
                <div class="text-end">
                    <SubmitButton :fields="fields" v-model="jobStack" :loading="loading" />
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import FormFields from "../../components/FormFields.vue";
import SubmitButton from "../../components/SubmitButton.vue";
import { mapActions } from "vuex";
import Fields from "../../utils/field-constants/jobStackFields";

export default {
    components: { FormFields, SubmitButton },
    data() {
        return {
            error: "",
            jobStack: {},
            loading: false,
            defaultFile: "",
            requiredFiles: [],
            fields: Fields
        };
    },
    name: "AddJobStack",
    computed: {
        templateJobs() {
            return this.$store.state.amdp.templateJobs;
        },
        templateJobOptions(){
            return this.templateJobs.map((job) => {
                return job.name
            })
        }
    },
    beforeMount() {
        if (!this.templateJobs.length) {
            this.$store.dispatch("amdp/fetchTemplateJobs");
        }
        this.fields = this.fields.map((field) => {
            if(field.name === 'jobs'){
                field.options = this.templateJobOptions;
            }
            return field
        })
    },
    methods: {
        ...mapActions({
            upsertJobStack: "amdp/upsertJobStack",
        }),
        async onCreateJobStack() {
            this.loading = true;
            let toastoptions;
            var self = this;
            try {
                await this.upsertJobStack(this.jobStack);
                toastoptions = {
                    message: "Job Stack created successfully.",
                    type: "success",
                };
            } catch (error) {
                this.loading = false;
                if (error.response.data.error) this.error = error.response.data.error;
                else this.error = error.message;
                toastoptions = {
                    message:
                        this.error ||
                        "Something went wrong when creating Job Stack. Please contact support.",
                    type: "error",
                };
                this.$store.dispatch("addToast", toastoptions);
                return;
            }
            this.loading = false;
            this.$store.dispatch("addToast", toastoptions);
            this.$router.push({
                name: "Job Stack",
                params: {
                    name: `${self.jobStack.name}`,
                },
            });

        }
    },
};
</script>

<style></style>